import React from 'react';
import { BarChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';

const mockData = [
  { month: 'Jan', newClients: 2, cac: 120 },
  { month: 'Feb', newClients: 3, cac: 110 },
  { month: 'Mar', newClients: 4, cac: 100 },
  { month: 'Apr', newClients: 5, cac: 90 },
  { month: 'May', newClients: 3, cac: 95 },
  { month: 'Jun', newClients: 6, cac: 80 },
  { month: 'Jul', newClients: 7, cac: 85 },
  { month: 'Aug', newClients: 5, cac: 90 },
  { month: 'Sep', newClients: 4, cac: 100 },
  { month: 'Oct', newClients: 6, cac: 95 },
  { month: 'Nov', newClients: 8, cac: 80 },
  { month: 'Dec', newClients: 9, cac: 75 },
];

interface CustomerChartProps {
  loading?: boolean;
  data?: any[];
}

const CustomerChart: React.FC<CustomerChartProps> = ({ loading, data }) => {
  const chartData = data && data.length > 0 ? data : mockData;
  return (
    <div className="bg-white rounded-xl shadow p-6 h-96 flex flex-col">
      <h3 className="text-lg font-bold mb-4">Aquisição de Clientes</h3>
      {loading ? (
        <div className="w-full h-full bg-gray-100 animate-pulse rounded-lg" />
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 16, right: 24, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" />
            <Tooltip />
            <Legend />
            <Bar yAxisId="left" dataKey="newClients" fill="#3B82F6" name="Novos Clientes" />
            <Line yAxisId="right" type="monotone" dataKey="cac" stroke="#F59E0B" strokeWidth={2} name="CAC" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default CustomerChart; 